import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//学生信息相关API

const student = {
    info: {
        queryList: config => createAPI('/baseInfo/student/queryList', 'post', config),

        item: config => createAPI('/baseInfo/student/item', 'post', config),

        save: config => createAPI('/baseInfo/student/save', 'post', config),

        status: config => createAPI('/baseInfo/student/status', 'post', config),

        importStu: config => createAPI('/baseInfo/student/importStu', 'post', config),

        exportStu: config => createAPI('/baseInfo/student/exportStu', 'post', config),

        uploadStuPhotoPackage: config => createAPI('/baseInfo/student/uploadStuPhotoPackage', 'post', config),

        uploadPhoto: config => createAPI('/baseInfo/student/uploadPhoto', 'post', config),

        delPhoto: config => createAPI('/baseInfo/student/delPhoto', 'post', config),

        downloadPhoto: config => createAPI('/baseInfo/student/downloadPhoto', 'post', config),

        supplementInfo: config => createAPI('/baseInfo/student/supplementInfo', 'post', config),

        yearDeptOption: config => createAPI('/baseInfo/student/yearDeptOption', 'post', config),

        majorOption: config => createAPI('/baseInfo/student/majorOption', 'post', config),

        classOption: config => createAPI('/baseInfo/student/classOption', 'post', config),

        exportInternalStu: config => createAPI('/baseInfo/student/exportInternalStu', 'post', config),

        queryAtSchoolStuList: config => createAPI('/baseInfo/student/queryAtSchoolStuList', 'post', config),

        exportAtSchoolStu: config => createAPI('/baseInfo/student/exportAtSchoolStu', 'post', config),

        loadClassCombo: config => createAPI('/baseInfo/student/loadClassCombo', 'post', config),

        queryStuChangeInfoList: config => createAPI('/baseInfo/student/queryStuChangeInfoList', 'post', config),
    },

    divide: {
        initCombo: config => createAPI('/student/divide/initCombo', 'post', config),

        deptCombo: config => createAPI('/student/divide/loadDeptCombo', 'post', config),

        majorCombo: config => createAPI('/student/divide/loadMajorCombo', 'post', config),

        list: config => createAPI('/student/divide/list', 'post', config),

        divide: config => createAPI('/student/divide/divide', 'post', config),
    },

    status: {
        initCombo: config => createAPI('/student/status/initCombo', 'post', config),

        list: config => createAPI('/student/status/list', 'post', config),

        loadClassComboByMajor: config => createAPI('/student/status/loadClassComboByMajor', 'post', config),

        save: config => createAPI('/student/status/save', 'post', config),

        submit: config => createAPI('/student/status/submit', 'post', config),

        updateAuditState: config => createAPI('/student/status/updateAuditState', 'post', config),

        del: config => createAPI('/student/status/del', 'post', config),

        export: config => createAPI('/student/status/export', 'post', config),

        verifyStuScore: config => createAPI('/student/status/verifyStuScore', 'post', config),

        queryAuditFlow: config => createAPI('/student/status/queryAuditFlow', 'post', config),
    },

    graduate: {
        init: config => createAPI('/student/graduate/init', 'post', config),

        yearList: config => createAPI('/student/graduate/yearList', 'post', config),

        initGraduateRequireCombo: config => createAPI('/student/graduate/initGraduateRequireCombo', 'post', config),

        graduateRequireList: config => createAPI('/student/graduate/graduateRequireList', 'post', config),

        saveGraduateRequire: config => createAPI('/student/graduate/saveGraduateRequire', 'post', config),

        create: config => createAPI('/student/graduate/create', 'post', config),

        submit: config => createAPI('/student/graduate/submit', 'post', config),

        initGraduateStuCombo: config => createAPI('/student/graduate/initGraduateStuCombo', 'post', config),

        graduateStuList: config => createAPI('/student/graduate/graduateStuList', 'post', config),

        addStu: config => createAPI('/student/graduate/addStu', 'post', config),

        delStu: config => createAPI('/student/graduate/delStu', 'post', config),

        graduateScoreList: config => createAPI('/student/graduate/graduateScoreList', 'post', config),

        stuList: config => createAPI('/student/graduate/stuList', 'post', config),

        scoreList: config => createAPI('/student/graduate/scoreList', 'post', config),

        handleAuditEvent: config => createAPI('/student/graduate/handleAuditEvent', 'post', config),

        cantGraduateStu: config => createAPI('/student/graduate/cantGraduateStu', 'post', config),

        statusChange: config => createAPI('/student/graduate/statusChange', 'post', config),

        cantGraduateExport: config => createAPI('/student/graduate/cantGraduateExport', 'post', config),

        exportStuList: config => createAPI('/student/graduate/exportStuList', 'post', config),
        
        queryAuditFlow: config => createAPI('/student/graduate/queryAuditFlow', 'post', config),
    },

    export: {
        exportFile: config => createAPI('/student/export/exportFile', 'post', config),

        batchExport: config => createAPI('/student/export/batchExport', 'post', config),

        initQueryCombo: config => createAPI('/student/export/initQueryCombo', 'post', config),

        printFile: config => createAPI('/student/export/printFile', 'post', config),

        uploadInfo: config => createAPI('/student/export/uploadInfo', 'post', config),
    }
};

export default student;



// WEBPACK FOOTER //
// ./src/api/modules/student.js